import { render } from "./HomeProj.vue?vue&type=template&id=1bf75e0e"
import script from "./HomeProj.vue?vue&type=script&lang=js"
export * from "./HomeProj.vue?vue&type=script&lang=js"

import "./HomeProj.vue?vue&type=style&index=0&id=1bf75e0e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__